import * as $ from 'jquery';
import 'bootstrap';
import 'html2canvas';

export class memberPrintCard {
	private replacementCard = $('.miles-replacement-card');
	private temporaryCard = $('.miles-temporary-card');

	getCookie(name:string): any {
		var value = "; " + document.cookie;
		var parts = value.split("; " + name + "=");
		var cookieVal:any;
		if (parts.length == 2) {
			cookieVal = parts.pop().split(";").shift();
			return cookieVal;
		}
	}
	populateCardOnLoad(): any {
		let _self = this;
		let cardContainer = $('.members--profile--print-card');

		$(document).ready(function() {
			if (cardContainer.length && _self.getCookie("phantom")) {
				var cardType   = "#"+JSON.parse(_self.getCookie("phantom")).memberStatus.charAt(0).toLowerCase();
				var userName   = JSON.parse(_self.getCookie("phantom")).userName;
				var number     = JSON.parse(_self.getCookie("phantom")).flyerID;
				var expiryDate = JSON.parse(_self.getCookie("phantom")).expiryDate;

				$(cardType).removeClass("hide");
				$(".card--username").html(userName);
				$(".card--number").html(number);

				if (expiryDate && expiryDate !== '') {
					$(".card--expiry").html(expiryDate);
				} else {
					$(".card--expiry").remove();
				}
			}
		});
	}

	initReplacementCard(): any {
		let _self = this;
		let repCardBtn = _self.replacementCard.find('#request-replacement-card-btn');
		let repCardNotice = _self.replacementCard.find('#replacement-card-success');

		repCardBtn.on('click', function(){
			repCardBtn.fadeOut(400, function(){
				repCardNotice.fadeIn();
			});
		});
	}

	initPrintSaveCard():any {
		let _self = this;
		let printBtn = _self.temporaryCard.find('#members-print-card');
		let saveBtn = _self.temporaryCard.find('#members-save-card');
		let cardImage = _self.temporaryCard.find('.members--card-image');
		let cardAspectRatio = 273/137;

		printBtn.on('click', (e:any) => {
			e.preventDefault();
			e.stopPropagation();

			html2canvas(cardImage[0], {
				onrendered: function(canvas:any) {
					let nW:any = window.open('','','width=600,height=400');
					nW.document.write('<img src="'+canvas.toDataURL()+'"/>');
					nW.focus();
					setTimeout(() => {
						nW.print();
						nW.close();
					}, 600);
				}
			});
		});

		saveBtn.on('click', (e:any) => {
			e.preventDefault();
			e.stopPropagation();

			html2canvas(cardImage[0], {
				onrendered: function(canvas:any) {
					_self.temporaryCard
					.append('<a class="hidden" id="temp-card-image-for-dl" href="'+canvas.toDataURL()+'" download="member-card.png">Download</a>');

					let tempDlBtn = $('#temp-card-image-for-dl');

					tempDlBtn[0].click();
				}
			});
		});
	}
}

let scopeRepl = document.querySelector('.miles-replacement-card');
let scopeTemp = document.querySelector('.miles-temporary-card');

try {
	let memberprintcard = new memberPrintCard();
	if (scopeRepl || scopeTemp) {
		memberprintcard.populateCardOnLoad();
	}

	if (scopeRepl) {
		memberprintcard.initReplacementCard();
	}
	if (scopeTemp) {
		memberprintcard.initPrintSaveCard();
	}
	
} catch(e) {console.error(e);}
